import React, { useState, useEffect } from "react";
//outsource
import { Row, Col, Layout } from "antd";
import { URL } from "../00_Nav/url";
//components
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";
import LayoutHeader from "../00_Nav/layout/layout_header";
import RequestFilter from "./component/request_filter";
import RequestTable from "./component/request_table";
//
import "./style.css";

//redux
import { useDispatch, useSelector } from "react-redux";

import {
  snapAllRequestByOwner,
  unSnapReq,
} from "../../store/request/request.action";
import { requestSelector } from "../../store/request/request.selector";
import LayoutFooter from "../00_Nav/layout/layout_footer";

const { Content } = Layout;

const RequestManagement = () => {
  // -------------------------- VAR --------------------------
  const breadCrumb = [
    { title: "Home", url: URL.home },
    { title: "Leave Request", url: URL.branch },
  ];
  // -------------------------- STATE --------------------------
  const [filter, setFilter] = useState(null);
  const [data, setData] = useState(null);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const requests = useSelector(requestSelector);

  // -------------------------- FUNCTION --------------------------
  const handleChange = (e) => {
    const value = e.target.value;
    setFilter(value);
  };
  // -------------------------- EFFECT --------------------------

  useEffect(() => {
    dispatch(snapAllRequestByOwner());

    return () => dispatch(unSnapReq());
  }, [dispatch]);

  useEffect(() => {
    if (requests) {
      setData(requests);
    }
  }, [requests]);

  //filter
  useEffect(() => {
    let data = requests || [];
    if (filter !== "All") {
      data = data?.filter((item) => item?.status === filter);
    }

    setData(data);
  }, [filter]);

  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row>
        <Col align="right" xl={24} lg={24} md={24} xs={24}>
          <span style={{ marginRight: 10, fontWeight: "bold" }}>Filter: </span>
          <RequestFilter handleChange={handleChange} />
        </Col>
        <Col style={{ marginTop: 20 }} xl={24} lg={24} md={24} xs={24}>
          <RequestTable data={data} />
        </Col>
      </Row>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <Content className="content page-content">
        <LayoutBreadCrumb data={breadCrumb} />
        {renderBody()}
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default RequestManagement;
